import { styled } from '@mui/material/styles'

const Grid = styled('section')`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  grid-gap: 2em;
`

export default Grid
